const METRICS_PREFIX = {
  SEQUENCE: "itemCardNested",
  NARRATIVE: "itemCardNarrativeNested"
};

export { METRICS_PREFIX };
